module.exports = __webpack_public_path__ + "static/favicon.68f24be8.ico";


//////////////////
// WEBPACK FOOTER
// ./src/static/favicons/favicon.ico
// module id = 354
// module chunks = 114276838955818